import { Tab, Tabs } from "@nextui-org/react";
import { IFrameMap } from "./IFrameMap";
import { IFrameList } from "./IFrameList";
import AboutArea from "./AboutArea";

type Props = {
  LanguageState: string;
  seAboutPageHeader: string;
  seAboutPageBody: string;
  enAboutPageHeader: string;
  enAboutPageBody: string;
};

export default function MobilePage({
  LanguageState,
  seAboutPageHeader,
  seAboutPageBody,
  enAboutPageHeader,
  enAboutPageBody,
}: Props) {
  return (
    <Tabs
      className="w-full"
      size="sm"
      variant="underlined"
      radius="none"
      aria-label="Tabs variants"
      classNames={{
        base: "w-full m-0",
        tab: "h-12 w-full max-w-[3rem] p-0 text-white",
        tabList:
          "h-safe-offset-14 fixed w-full gap-1 md:gap-20 p-0 pb-safe px-safe z-[1010] m-auto left-0 right-0 bottom-0 flex w-full justify-around lg:justify-center z-10 bg-gradient-to-t dark:from-zinc-900/95 dark:to-zinc-800/95 from-zinc-200/95 to-zinc-100/95 border-t border-t-zinc-300 dark:border-t-zinc-700",
        tabContent:
          "h-10 text-zinc-900 dark:text-zinc-200 group-data-[selected=true]:text-lunet-red-500 dark:group-data-[selected=true]:text-lunet-yellow-500 text-[0.6rem] lg:text-xxs",
        cursor:
          "top-0 pt-[2px] rounded-b-3xl group-data-[selected=true]:bg-lunet-red-500 dark:group-data-[selected=true]:bg-lunet-yellow-500",
        panel:
          "absolute top-0 left-0 right-0 bottom-0 m-0 py-0 px-0 flex flex-col w-full",
      }}
    >
      <Tab
        data-umami-event="Tab - Map View"
        key="Map"
        title={
          <div className="flex flex-col justify-center items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z"
              />
            </svg>
            <span>
              {LanguageState === "swedish" ? (
                <p className="text-xxs">Karta</p>
              ) : (
                <p className="text-xxs">Map</p>
              )}
            </span>
          </div>
        }
      >
        <IFrameMap language={LanguageState} />
      </Tab>
      <Tab
        data-umami-event="Tab - List View"
        key="List"
        title={
          <div className="flex flex-col justify-center items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z"
              />
            </svg>
            <span>
              {LanguageState === "swedish" ? (
                <p className="text-xxs">Listvy</p>
              ) : (
                <p className="text-xxs">List view</p>
              )}
            </span>
          </div>
        }
      >
        <IFrameList language={LanguageState} />
      </Tab>
      <Tab
        data-umami-event="Tab - About View"
        key="About"
        title={
          <div className="flex flex-col justify-center items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
              />
            </svg>
            <span>
              {LanguageState === "swedish" ? (
                <p className="text-xxs">Om</p>
              ) : (
                <p className="text-xxs">About</p>
              )}
            </span>
          </div>
        }
      >
        <AboutArea
          LanguageState={LanguageState}
          seAboutPageHeader={seAboutPageHeader}
          seAboutPageBody={seAboutPageBody}
          enAboutPageHeader={enAboutPageHeader}
          enAboutPageBody={enAboutPageBody}
        />
      </Tab>
    </Tabs>
  );
}
